import { BasicsClass } from '@/common/BasicsClass';
import { Util } from '@/common/util';

export class IdolAbnormalGoodsOrderDetailAPI extends BasicsClass {
    public apiUrls: any = new Map([
        ['getAbnormalOrderDetail', {
            url: '/admin/ktv/goods/exception/show',
            name: 'sale-machine-abormal-goods-order-detail',
            label: '大明星售卖柜商品异常订单详情'
        }],

        ['addSaleMachineBlackUser', {
          url: '/admin/ktv/seller_blacklist/add',
          name: 'add',
          label: '大明星添加黑名单'
        }],

        ['noNeedHandlePayMore', {
          url: '/admin/ktv/goods/exception/notHandle',
          name: 'no-need-handle-pay-more',
          label: '大明星确认无须补款'
        }]
    ])

    // 售卖柜商品异常订单详情
    public getAbnormalOrderDetail(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
        const apiUrls = this.apiUrls

        const url = apiUrls.get('getAbnormalOrderDetail').url

        this.BasicPost(url, {
            ...params
        }, false, false, false, successCb, failCb, showLoading)
    }

     // 添加售卖柜黑名单
    public addSaleMachineBlackUser(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
      const apiUrls = this.apiUrls

      const url = apiUrls.get('addSaleMachineBlackUser').url

      this.BasicPost(url, {
          ...params
      }, false, false, false, successCb, failCb, showLoading)

    }

    // 确认无须补款
    public noNeedHandlePayMore(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
      const apiUrls = this.apiUrls

      const url = apiUrls.get('noNeedHandlePayMore').url

      this.BasicPost(url, {
          ...params
      }, false, false, false, successCb, failCb, showLoading)

      
    }
    
}